import { DeviceInfo } from '@jarvis/jweb-core'
import * as DeviceResource from '@jarvis/react-device-resources-provider'
import type {
  ConnectivityToApp,
  ExperienceType
} from '../interface/controllerInterface'
import {
  Container,
  SessionPayload,
  Entry
} from '../interface/controllerInterface'
import { Logger } from '../utils/helperMethods'
import { DeviceSupplier } from './DeviceProvider/DeviceSupplier'
import { LaunchParam } from './LaunchOptionsLoader'
import { LaunchDarklyService } from '../utils/launchDarklyService'
import { FEATURE_FLAGS } from '../utils/featureFlags'

export class SessionPayloadManager {
  public static create = async (
    deviceSupplier: DeviceSupplier
  ): Promise<SessionPayloadManager> => {
    //
    Logger.log('SessionPayload.create method called')

    return new SessionPayloadManager(deviceSupplier)
  }

  public createSessionPayload = async (
    clientId: string,
    connectivity: ConnectivityToApp,
    deviceResources: DeviceResource.DeviceResource[],
    launchParam: LaunchParam,
    experienceType?: ExperienceType
  ): Promise<SessionPayload> => {
    //
    const deviceInfo: DeviceInfo = this.deviceSupplier.getDeviceInfo()
    let onboardingContextEntry = Entry.APP_OOBE
    if (launchParam.onboardingContextEntry != null) {
      onboardingContextEntry = launchParam.onboardingContextEntry
    }

    const shouldOverrideIpadOS = await LaunchDarklyService.getFlagValue(
      FEATURE_FLAGS.ENABLE_IPADOS_DEVICE_PLATFORM_OVERRIDE,
      false
    )

    const osType =
      deviceInfo.platform === 'mac' ||
      (deviceInfo.platform === 'ipados' && shouldOverrideIpadOS)
        ? 'macos'
        : deviceInfo.platform

    const sessionPayload: SessionPayload = {
      onboardingContext: {
        entry: onboardingContextEntry,
        ...(experienceType && { experience: experienceType })
      },
      app: {
        clientId,
        appVersion: deviceInfo.appVersion,
        osType,
        osVersion: deviceInfo.osVersion,
        countryRegionIso: deviceInfo.locale.country,
        locale: deviceInfo.locale.languageTag,
        container: Container.JARVIS_APP
      },
      device: {
        connectivityToApp: connectivity,
        deviceResources: deviceResources
      }
    }

    // Check optional tags
    if (launchParam.bizModel) {
      sessionPayload.device.bizModel = launchParam.bizModel
    }
    if (launchParam.offer) {
      sessionPayload.device.offer = launchParam.offer
    }
    if (launchParam.appInstanceId) {
      sessionPayload.app.appInstanceId = launchParam.appInstanceId
    }

    return sessionPayload
  }

  private constructor(deviceSupplier: DeviceSupplier) {
    this.deviceSupplier = deviceSupplier
  }

  private deviceSupplier: DeviceSupplier
}
